import React, { type PropsWithChildren } from 'react';
import MockAuthContextProvider, { AuthState } from '../auth/MockMsalAuthContextProvider';
import MockChatServiceProvider from '../chat/MockChatServiceProvider';
import MockAppInfoServiceProvider from '../app-info/MockAppInfoServiceProvider';
import MockBackendEventsServiceProvider from '../backend-events/MockBackendEventsServiceProvider';
import MockAdaptiveProvider from '../adaptive/MockAdaptiveProvider';
import LayoutProvider from '../layout/LayoutContext';
import EnvConfigHelper from '../../helpers/envConfigHelper';

const isUiTest = EnvConfigHelper.get('ui-test') === 'true';

const MockContextBootstrap: React.FC<PropsWithChildren<{ authState?: Partial<AuthState>; }>> = ({ children, authState: authStateOverride }) => {
    const content = (
        <MockAuthContextProvider state={authStateOverride}>
            <MockBackendEventsServiceProvider>
                <MockAppInfoServiceProvider>
                    <MockAdaptiveProvider>
                        <MockChatServiceProvider>
                            {children}
                        </MockChatServiceProvider>
                    </MockAdaptiveProvider>
                </MockAppInfoServiceProvider>
            </MockBackendEventsServiceProvider>
        </MockAuthContextProvider>
    );

    return isUiTest ? <LayoutProvider>{content}</LayoutProvider> : content;
};

export default MockContextBootstrap;